import Tab from 'semantic-ui-react/dist/commonjs/modules/Tab';
import './styles.css';

export default Tab;
